module.exports = __webpack_public_path__ + "static/media/1001064MF.0386688f.jpg";